import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const lastVisitedStore = {}; // shared across hook calls

const useLastVisited = () => {
  const location = useLocation();

  useEffect(() => {
    // Store the current location
    lastVisitedStore[location.pathname] = location.pathname + location.search;
  }, [location]);

  // Function to clear a specific path or all paths
  const clearLastVisited = (pathname) => {
    if (pathname) {
      delete lastVisitedStore[pathname];
    } else {
      // Clear everything
      Object.keys(lastVisitedStore).forEach(
        (key) => delete lastVisitedStore[key]
      );
    }
  };

  return { lastVisitedStore, clearLastVisited };
};

export default useLastVisited;
